export const updateDatiModPagCarta = (unDato, unActionType) => {
    return {
        type: unActionType,
        unDato
    }
}